module.exports = __webpack_public_path__ + "static/logo-the-catch-17bc7cefa130aa9ce2ab0df44125e2ab.svg";